module.exports = __webpack_public_path__ + "static/media/Carnival.876fa64e.svg";